import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

const Copyright = (props: any) => {
  return (
    <Typography variant="body2" color="secondary.main" align="center" {...props}>
      {'Copyright © '}
      <Link target="_blank" color="inherit" href="https://www.linkedin.com/in/dudi-kaplan-b44b00196/">
        Dudik
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
};

export default Copyright;
